import { db } from '../config/firebaseconfig'
import timestamper from './timestamper'
import disarrayify from './disarrayify'

/*
assignmentId: String
units: Array
unitIndex: Number
upQ: Boolean
{
  moving: Function
  movingSuccess: Function
  movingError: Function
}
*/

export default function moveUnit (assignmentId, units, unitIndex, upQ, setActiveAssignmentUnits, {isSaving, savingSuccess, savingError}) {
  isSaving()
  let unitArray = units.slice(0)
  const targetUnit = units[unitIndex]
  let indexMovingTo = unitIndex
  if (upQ === true) {
    indexMovingTo = unitIndex - 1
  } else if (upQ === false ) {
    indexMovingTo = unitIndex + 1
  }
  unitArray.splice(unitIndex, 1)
  unitArray.splice(indexMovingTo, 0, targetUnit)
  const unitObj = disarrayify(unitArray, 'answers')
  db.collection('assignments').doc(assignmentId).update({units: unitObj})
    .then(() => {
      savingSuccess()
      setActiveAssignmentUnits({assignmentUnits: unitArray, timestamp: timestamper()})
    })
    .catch((err) => savingError(err))
}


// c index is 2

// [a, b, c, d, e]

// remove c [a, b, d, e]

// splice in c at 1 to go up [a, c, b, d, e]

// splice in c at 3 to go down [a, b, d, c, e]


// WEBPACK FOOTER //
// ./src/helpers/moveUnit.js